var map = {
	"./01.webp": "./src/assets/01.webp",
	"./02.webp": "./src/assets/02.webp",
	"./03.webp": "./src/assets/03.webp",
	"./04.webp": "./src/assets/04.webp",
	"./5.png": "./src/assets/5.png",
	"./Co2.jpg": "./src/assets/Co2.jpg",
	"./Final-Logo.png": "./src/assets/Final-Logo.png",
	"./api.webp": "./src/assets/api.webp",
	"./aws.png": "./src/assets/aws.png",
	"./azure.png": "./src/assets/azure.png",
	"./backendDevelopment.jpg": "./src/assets/backendDevelopment.jpg",
	"./barry.jpeg": "./src/assets/barry.jpeg",
	"./bg.webp": "./src/assets/bg.webp",
	"./bluetooth.jpg": "./src/assets/bluetooth.jpg",
	"./car.mp4": "./src/assets/car.mp4",
	"./car.webp": "./src/assets/car.webp",
	"./ceo.png": "./src/assets/ceo.png",
	"./forimazoodri.png": "./src/assets/forimazoodri.png",
	"./hayk.png": "./src/assets/hayk.png",
	"./heart.webp": "./src/assets/heart.webp",
	"./jazz.png": "./src/assets/jazz.png",
	"./logo.png": "./src/assets/logo.png",
	"./mobilitysolution.jpg": "./src/assets/mobilitysolution.jpg",
	"./mysvg.svg": "./src/assets/mysvg.svg",
	"./p.png": "./src/assets/p.png",
	"./sapNs2.png": "./src/assets/sapNs2.png",
	"./sharebg.webp": "./src/assets/sharebg.webp",
	"./sharing.webp": "./src/assets/sharing.webp",
	"./telenor.png": "./src/assets/telenor.png",
	"./undp.png": "./src/assets/undp.png",
	"./velocity.png": "./src/assets/velocity.png",
	"./winifred.jpeg": "./src/assets/winifred.jpeg",
	"./world.webp": "./src/assets/world.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";